import { connect } from "react-redux";
import { KPTable } from "../components/KPTable";
import { cursedRegister, gotoFirst, gotoNext, gotoPrev } from "../actions/actions";
import { doCursedCallLoaderFunc } from "../actions/thunks";
import { changeDirtyFilter, changeGlobalCheckAll, changePageSize } from "../../kptable/actions/actions";
function mapStateToProps({ kpcursedtable }, { id }) {
    return {
        table: kpcursedtable[id],
    };
}
function mapDispatchToProps(dispatch) {
    return {
        onCallLoaderFunc: (id, loaderFunc, silent) => dispatch(doCursedCallLoaderFunc(id, loaderFunc, silent)),
        onRegister: (id, state) => dispatch(cursedRegister(id, state)),
        onGoToFirst: async (id, loaderFunc) => {
            dispatch(gotoFirst(id));
            await dispatch(doCursedCallLoaderFunc(id, loaderFunc));
        },
        onGoToNext: async (id, loaderFunc) => {
            dispatch(gotoNext(id));
            await dispatch(doCursedCallLoaderFunc(id, loaderFunc));
        },
        onGoToPrev: async (id, loaderFunc) => {
            dispatch(gotoPrev(id));
            await dispatch(doCursedCallLoaderFunc(id, loaderFunc));
        },
        onChangePageSize: async (id, newPageSize, loaderFunc) => {
            dispatch(changePageSize(id, newPageSize));
            dispatch(gotoFirst(id));
            await dispatch(doCursedCallLoaderFunc(id, loaderFunc));
        },
        onChangeDirtyFilter: (id, name, value) => dispatch(changeDirtyFilter(id, name, value)),
        onChangeGlobalCheckAll: (id, all) => dispatch(changeGlobalCheckAll(id, all)),
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(KPTable);
